import { Restaurant } from 'shared-types/Common';
import { ONE_DAY_IN_MS } from '@utils/helpers';
import moment from 'moment';

const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Return a modified array of dates matching those unavailable to the restaurant
export const getDisabledDates = (
  dates,
  closedDates,
  restaurantConfig: Restaurant,
  timeSlots: any = []
) => {
  const reducedSlots = timeSlots.reduce(
    (prev, cur) => ({ ...prev, [cur.date]: cur.data.timeSlots }),
    []
  );

  const advanceBookingDaysLimit = restaurantConfig?.acceptBookingsDaysInAdvance
    ? restaurantConfig.acceptBookingsDaysInAdvance * ONE_DAY_IN_MS
    : 0;

  const today = new Date().setHours(0, 0, 0, 0);

  const isExceedingBookingInAdvance = (date) =>
    restaurantConfig && restaurantConfig.acceptBookingsDaysInAdvance
      ? new Date(date).getTime() - today > advanceBookingDaysLimit
      : false;

  const hasNoTimeAvailable = (date) => {
    const formattedDate = moment(date).format('YYYY-MM-DD').toString();
    return reducedSlots[formattedDate]?.length === 0;
  };

  const closedDays = closedDates ? closedDates.closedDays : [];
  const isDayClosed = (day) => closedDays.includes(weekdays[new Date(day).getDay()]);

  return dates.reduce(
    (disabledObject, { date }) => ({
      ...disabledObject,
      [date]: isDayClosed(date) || isExceedingBookingInAdvance(date) || hasNoTimeAvailable(date),
    }),
    {}
  );
};

export const findFirstAvailableDate = (dates, disabledDates = {}) =>
  dates ? dates.find((date) => !disabledDates[date]) : null;
